import { sideTabTitle, sideTabCard } from "../../data/SideTabData";
import { MobileWrapper, MobileCard } from "./styles"

export default function SideTabMobile() {
    return (
      <MobileWrapper>
        {sideTabCard.map((card, index) => (
          <MobileCard key={index}>
            <div className="MobileTitle">{sideTabTitle[index].title}</div>
            <div className="MobileImage">
              <img src={card.image} alt="Imagens feitas com IA para representar tecnologia"/>
            </div>
            <div className="MobileDescription">{card.description}</div>
            <div className="MobileOverlayTitle">{card.overlayTitle}</div>
            <div className="MobileOverlaySubtitle">{card.overlaySubtitle}</div>
          </MobileCard>
        ))}
      </MobileWrapper>
    );
  }
  